import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FMIconButton, FMTextInput } from 'atoms';
import style from './SearchInput.style';

interface Props {
    searchNode: (text: string) => void;
    classes: any;
    placeholder: string;
}

interface State {
    text: string;
}

class SearchInput extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = {
            text: '',
        };
    }

    private updateText = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ text: event.target.value });
    }

    private keyPressed = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            this.searchNode();
        }
    }

    private searchNode = () => {
        this.props.searchNode(this.state.text);
    }

    public render() {
        const { classes } = this.props;

        return (
            <div className={classes.searchContainer}>
                <FMTextInput
                    className={classes.searchInput}
                    type="text"
                    placeholder={this.props.placeholder}
                    value={this.state.text}
                    onChange={this.updateText}
                    onKeyPress={this.keyPressed}
                />
                <FMIconButton
                    color="secondary"
                    className={classes.searchButton}
                    onClick={this.searchNode}
                    type={'search'}
                />
            </div>
        );
    }

}

export default withStyles(style)(SearchInput);
